/**
 * Reusable empty state component
 * Displays a message when there's no data to show
 */

import React from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/**
 * Empty state component for displaying when no data is available
 *
 * @example
 * {requests.length === 0 ? (
 *   <EmptyState
 *     title="신청된 수업이 없습니다"
 *     description="새로운 신청이 들어오면 여기에 표시됩니다."
 *   />
 * ) : (
 *   // ... render data
 * )}
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  className = '',
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {icon && <div className="empty-state-icon">{icon}</div>}
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;
